// @flow
import React, { Component } from 'react'
import styled, { type StyledComponent } from 'styled-components'

const Wrapper: StyledComponent<
  { color?: string, block?: boolean, float?: boolean },
  any,
  any
> = styled.div`
  display: inline-block;
  background-color: ${({ color }) => color || '#77b9de'};
  ${({ block }) => (block ? 'display: block;' : '')} ${({ float }: Object) =>
    float ? 'float: left;' : ''};
`

type Props = {|
  width: number,
  ratio: number,
  block?: boolean,
  float?: boolean,
  color?: string
|}

export default class ResponsibleRect extends Component<Props> {
  render() {
    const { block, float, color } = this.props
    return <Wrapper style={this.styles()} float={float} block={block} color={color} />
  }

  styles() {
    const { width, ratio } = this.props
    return { width, height: width / ratio }
  }
}
